/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfLeadDashboardDto } from "../models/AjaxResponseOfLeadDashboardDto";
import type { AjaxResponseOfLeadDto } from "../models/AjaxResponseOfLeadDto";
import type { AjaxResponseOfPagedResultDtoOfLeadDto } from "../models/AjaxResponseOfPagedResultDtoOfLeadDto";
import type { LeadDashboardFilterDto } from "../models/LeadDashboardFilterDto";
import type { UpdateLeadDto } from "../models/UpdateLeadDto";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class LeadsAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AjaxResponseOfPagedResultDtoOfLeadDto Success
   * @throws ApiError
   */
  public getAllLeads({
    filter,
    companyIdFilter,
    isViewedFilter,
    remarketingStatusFilter,
    sellerIdFilter,
    externalProviderFilter,
    startDate,
    endDate,
    sorting,
    skipCount,
    maxResultCount,
  }: {
    filter?: string;
    companyIdFilter?: number;
    isViewedFilter?: boolean;
    remarketingStatusFilter?: number;
    sellerIdFilter?: number;
    externalProviderFilter?: string;
    startDate?: string;
    endDate?: string;
    sorting?: string;
    skipCount?: number;
    maxResultCount?: number;
  }): CancelablePromise<AjaxResponseOfPagedResultDtoOfLeadDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/leads",
      query: {
        filter: filter,
        companyIdFilter: companyIdFilter,
        isViewedFilter: isViewedFilter,
        remarketingStatusFilter: remarketingStatusFilter,
        sellerIdFilter: sellerIdFilter,
        externalProviderFilter: externalProviderFilter,
        startDate: startDate,
        endDate: endDate,
        sorting: sorting,
        skipCount: skipCount,
        maxResultCount: maxResultCount,
      },
    });
  }
  /**
   * @returns AjaxResponseOfLeadDto Success
   * @throws ApiError
   */
  public updateLead({
    requestBody,
  }: {
    requestBody?: UpdateLeadDto;
  }): CancelablePromise<AjaxResponseOfLeadDto> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/front-end/v1/leads",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns AjaxResponseOfLeadDashboardDto Success
   * @throws ApiError
   */
  public getDashboardData({
    requestBody,
  }: {
    requestBody?: LeadDashboardFilterDto;
  }): CancelablePromise<AjaxResponseOfLeadDashboardDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/leads/dashboard",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns AjaxResponseOfLeadDto Success
   * @throws ApiError
   */
  public getLeadById({
    id,
  }: {
    id: string;
  }): CancelablePromise<AjaxResponseOfLeadDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/leads/{id}",
      path: {
        id: id,
      },
    });
  }
}
